import React, { FunctionComponent } from 'react';

import { forNamespace } from 'app/common/lib/util/i18n';
import { PrimaryButton } from 'app/common/components/controls/button/button';
import { OnboardingDialog } from './OnboardingDialog';
import { LinkWrapper } from 'app/common/components/singlespa/link-wrapper';

import { AtlassianAccountOnboardingLinks } from './AtlassianAccountOnboardingLinks';
// eslint-disable-next-line @trello/less-matches-component
import styles from './AtlassianAccountOnboardingOverlay.less';

const format = forNamespace(['aa onboarding', 'dialog']);
interface NotWorkProps {
  orgName: string;
  onClickGoBack: () => void;
  onDismiss: () => void;
  onClickRemove: () => void;
  image?: HTMLImageElement;
}

export const NotWork: FunctionComponent<NotWorkProps> = ({
  image,
  orgName,
  onClickGoBack,
  onDismiss,
  onClickRemove,
}) => (
  <OnboardingDialog
    title={format('one last step')}
    helpLink={AtlassianAccountOnboardingLinks.Help}
    closeDialog={onDismiss}
    image={image}
  >
    <div>{format('remove org emails message', { org: orgName })}</div>
    <div className={styles.section}>
      <LinkWrapper href="/me" role="link">
        <PrimaryButton onClick={onClickRemove}>
          {format('remove org emails settings button', { org: orgName })}
        </PrimaryButton>
      </LinkWrapper>
    </div>
    <div className={styles.item}>
      <a role="link" onClick={() => onClickGoBack()}>
        {format('go back')}
      </a>
    </div>
  </OnboardingDialog>
);
